import MoreOutlined from '@ant-design/icons/lib/icons/MoreOutlined'
import Button from 'antd/lib/button'
import Dropdown from 'antd/lib/dropdown'
import { ToolbarActionType } from 'Core/Workbench'
import { ContainerType, TaskConfigType } from 'Types/Tasks.types'
import { sendAnalyticsTrack } from 'Utils/analytics.utils'
import classes from '../ActionsContainer.module.less'

type CollapsedActionsPropsType = {
    collapsedActions: ToolbarActionType[]
    taskConfig: TaskConfigType<ContainerType, unknown>
}

export const CollapsedActions = (props: CollapsedActionsPropsType) => {
    const { collapsedActions, taskConfig } = props

    const getCommonAnalyticsObject = () => {
        return {
            project_id: taskConfig.assignment.project_id,
            task_id: taskConfig.assignment.task.id,
            user_id: taskConfig.assignment.user_id,
            step_id: taskConfig.assignment.step?.id,
        }
    }

    return (
        <>
            {collapsedActions.length > 0 && (
                <Dropdown
                    menu={{
                        items: collapsedActions.map(action => {
                            return {
                                key: action.id,
                                label: action.title,
                                onClick: action.onClick,
                                disabled:
                                    typeof action.disabled === 'function'
                                        ? action.disabled()
                                        : action.disabled,
                            }
                        }),
                    }}
                    trigger={['click']}
                    placement="bottomRight"
                    className={classes.dropdownBtn}
                >
                    <Button
                        icon={<MoreOutlined />}
                        onClick={() =>
                            sendAnalyticsTrack('MenuOpened_Clicked', {
                                ...getCommonAnalyticsObject(),
                            })
                        }
                    ></Button>
                </Dropdown>
            )}
        </>
    )
}
